import {Pane} from "evergreen-ui";
import React from "react";

const DefaultDataView = (params) => {
  return (
    <Pane>---</Pane>
  )
};

export default DefaultDataView;